module.exports = __webpack_public_path__ + "img/news01.269020b.png";